import {LoginMethodMin} from "platformed-client/types";
import {HStack, Image} from "@chakra-ui/react";
import GoogleLogo from "../../assets/google.svg";
import MicrosoftLogo from "../../assets/microsoft.svg";
import SamlLogo from "../../assets/saml.png";
import {Tag} from "./ui/tag.tsx";
import {unreachableCase} from "../utils/typescript";
import T from "platformed-components/i18n/T";
import useTranslate from "platformed-components/i18n/useTranslate";

const SsoAuthMethodTag = ({iconUrl, name}: {iconUrl: string; name: string}) => (
  <Tag colorPalette="gray">
    <HStack gap={0}>
      <Image h="3" mr="2" src={iconUrl} alt={name} aspectRatio={1} /> {name}
    </HStack>
  </Tag>
);

export const AuthMethodTag = ({loginMethod, enabled2fa}: {loginMethod?: LoginMethodMin; enabled2fa: boolean}) => {
  const t = useTranslate();
  if (loginMethod) {
    switch (loginMethod.inner.type) {
      case "GoogleOAuth":
        return <SsoAuthMethodTag iconUrl={GoogleLogo} name={t("c.Login_with_Google")} />;
      case "MicrosoftOAuth":
        return <SsoAuthMethodTag iconUrl={MicrosoftLogo} name={t("c.Login_with_Microsoft")} />;
      case "GenericSaml":
        return <SsoAuthMethodTag iconUrl={SamlLogo} name={loginMethod.name} />;
      case "UsernamePassword":
        if (enabled2fa) {
          return (
            <Tag colorPalette="green">
              <T keyName="c.Password_&_2FA" />
            </Tag>
          );
        } else {
          return (
            <Tag colorPalette="blue">
              <T keyName="c.Password" />
            </Tag>
          );
        }
      case "GenericOauth":
        return <Tag colorPalette="gray">{loginMethod.name}</Tag>;
      default:
        unreachableCase(loginMethod.inner);
    }
  } else {
    return null;
  }
};
